import { Link } from 'react-router-dom';
import HeroSection from './HeroSection';
import HorizontalScrollBar from './HorizontalScrollBar';
import ScrollableCards from './ScrollableCards';
import ContentSection from './ContentSection';
import Accordion from './Accordion';
import GetStarted from './GetStarted';
import { useMediaQuery } from 'react-responsive';
import PaymentAccordion from './paymentAccordion/PaymentAccordion';

const items = [
  { name: 'What is SmallSmall?', link: '/about-us' },
  { name: 'How it works', link: '#' },
  { name: 'Get started', link: '/sign-up' },
  { name: 'FAQs', link: 'https://help.smallsmall.com/SmallSmall/directories' },
];

const benefitsData = [
  {
    title: 'Flexible Payments.',
    description:
      'Choose your plan: 35% or 50% down, spread the rest over 3-6 months. No hidden fees, ever.',
  },
  {
    title: 'Shop with Confidence.',
    description:
      '1,000+ quality vetted products - from gadgets to homes and  essentials. All at fair prices.',
  },
  {
    title: 'Budget friendly.',
    description:
      "Our AI tool helps you plan payments that won't break your monthly flow. ",
  },
  {
    title: 'Instant Approval',
    description:
      'Get approved in minutes, not days. Shop today, pay SmallSmall tomorrow.',
  },
];

function HowItWorks() {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      <HeroSection />
      <HorizontalScrollBar items={items} />
      <ContentSection
        title="Shop with confidence, live with flexibility"
        description="SmallSmall is the way we believe shopping should be. With our flexible instalment payment options, you can shop with confidence, knowing you have an affordable way to pay for your purchases."
      >
        <p>What is SmallSmall?</p>
      </ContentSection>
      <ScrollableCards cards={benefitsData} />
      <ContentSection
        title="How SmallSmall works"
        description="SmallSmall makes it easy to own what you love without straining your budget. Simply choose your favorite item, select a flexible payment plan, and enjoy it right away while paying over time."
      />

      <PaymentAccordion />

      <ContentSection
        title="Get Started with SmallSmall"
        description="Own what you love, your way. Sign up in minutes and start shopping with flexible payment options tailored to your budget."
      />
      <GetStarted />

      <Accordion>
        <div className="flex justify-between my-10 align-bottom items-baseline ">
          <h2 className="text-[35px]">
            Still have more questions about SmallSmall?
          </h2>

          <Link
            to="https://help.smallsmall.com/smallsmall/directories"
            className="text-sm hidden md:block"
          >
            See all FAQ
          </Link>
        </div>
      </Accordion>
    </>
  );
}

export default HowItWorks;
